import { render, staticRenderFns } from "./FamilyMembers.vue?vue&type=template&id=8ade777e&"
import script from "./FamilyMembers.vue?vue&type=script&lang=js&"
export * from "./FamilyMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports